import React from 'react';
import { NodeSubtype, NodeType } from '../../types';
import { useSessionStore } from '../../store/sessionStore';
import NodeFormPopup from './NodeFormPopup';

interface NodeEditPopupProps {
  nodeId: string;
  screenX: number;
  screenY: number;
  onClose: () => void;
}

const NodeEditPopup: React.FC<NodeEditPopupProps> = ({ nodeId, screenX, screenY, onClose }) => {
  const nodes = useSessionStore(s => s.nodes);
  const updateNode = useSessionStore(s => s.updateNode);
  const removeNode = useSessionStore(s => s.removeNode);
  const node = nodes[nodeId];

  if (!node) {
    return null;
  }

  const handleConfirm = (label: string, type: NodeType, subtype: NodeSubtype) => {
    updateNode(nodeId, { label: label.trim() || node.label, type, subtype });
    onClose();
  };

  const handleDelete = () => {
    onClose();
    removeNode(nodeId);
  };

  return (
    <NodeFormPopup
      title="Editar nodo"
      initialLabel={node.label}
      initialType={node.type}
      initialSubtype={node.subtype}
      allowDelete
      onConfirm={handleConfirm}
      onDelete={handleDelete}
      onClose={onClose}
      screenX={screenX}
      screenY={screenY}
    />
  );
};

export default NodeEditPopup;
